function Error403() {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(225deg, #4338ca 0%, #312e81 100%)',
      color: '#ffffff',
      fontFamily: 'Poppins-Medium',
      padding: '20px',
      textAlign: 'center'
    }}>
      <h1 style={{ fontSize: '4rem', margin: '0', marginBottom: '20px' }}>403</h1>
      <h2 style={{ fontSize: '1.5rem', marginBottom: '20px' }}>Accès Refusé</h2>
      <p style={{ fontSize: '1.1rem', color: '#c7d2fe', maxWidth: '500px' }}>
        Désolé, vous n'avez pas l'autorisation d'accéder à cette page.
      </p>
      <a 
        href="/"
        style={{
          marginTop: '30px',
          padding: '12px 25px',
          background: 'rgba(255, 255, 255, 0.1)',
          borderRadius: '15px',
          color: '#ffffff',
          textDecoration: 'none',
          border: '2px solid rgba(255, 255, 255, 0.2)',
          transition: 'all 0.3s ease'
        }}
        onMouseOver={e => {
          e.currentTarget.style.background = 'rgba(255, 255, 255, 0.2)';
          e.currentTarget.style.transform = 'translateY(-3px)';
        }}
        onMouseOut={e => {
          e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
          e.currentTarget.style.transform = 'translateY(0)';
        }}
      >
        Retour à l'accueil
      </a>
    </div>
  );
}

export default Error403; 